import { Box, Container, Grid, GridItem, Flex } from '@chakra-ui/react';

import ImageShimmer from '../ImageShimmer/ImageShimmer';

export default function Companies() {
  const companies: {
    name: string;
    imageSrc: string;
    imageSize: {
      w: number;
      h: number;
    };
  }[] = [
    {
      name: 'Hims & Hers',
      imageSrc: '/images/resources/companies/hims-hers.svg',
      imageSize: {
        w: 150.45,
        h: 23.58,
      },
    },
    {
      name: 'Athena Club',
      imageSrc: '/images/resources/companies/athena-club.svg',
      imageSize: {
        w: 151.06,
        h: 18.92,
      },
    },
    {
      name: 'Crew',
      imageSrc: '/images/resources/companies/crew.svg',
      imageSize: {
        w: 81.74,
        h: 26.92,
      },
    },
    {
      name: 'Lumin',
      imageSrc: '/images/resources/companies/lumin.png',
      imageSize: {
        w: 140,
        h: 16,
      },
    },
    {
      name: 'Transfix',
      imageSrc: '/images/resources/companies/transfix.png',
      imageSize: {
        w: 174,
        h: 21,
      },
    },
    {
      name: 'PresenceLearning',
      imageSrc: '/images/resources/companies/presence-learning.svg',
      imageSize: {
        w: 197.59,
        h: 31.94,
      },
    },
    {
      name: 'Armory',
      imageSrc: '/images/resources/companies/armory.svg',
      imageSize: {
        w: 124.31,
        h: 34.18,
      },
    },
    {
      name: 'Lob',
      imageSrc: '/images/resources/companies/lob.svg',
      imageSize: {
        w: 56.45,
        h: 26,
      },
    },
    {
      name: 'EasyKnock',
      imageSrc: '/images/resources/companies/easyknock.png',
      imageSize: {
        w: 147.61,
        h: 32,
      },
    },
    {
      name: 'Earnin',
      imageSrc: '/images/resources/companies/earnin.svg',
      imageSize: {
        w: 124.03,
        h: 30.76,
      },
    },
  ];

  return (
    <Box p={{ base: '2.8rem 0 4rem', lg: '3.5rem 0 5rem' }} bgColor="#fff">
      <Container maxW={{ lg: '960px' }}>
        <Box
          fontSize="1rem"
          fontWeight="700"
          color="#909090"
          textAlign="center"
          lineHeight="1.375rem"
          letterSpacing="0.0625rem"
          textTransform="uppercase"
          mb={{ base: '2rem', lg: '2.5rem' }}
        >
          Build a thriving remote team with Terminal
        </Box>
        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
            xl: 'repeat(5, 1fr)',
          }}
          gap={{ base: '2rem 1rem', lg: '3.5rem' }}
        >
          {companies.map((company) => (
            <GridItem key={company.name}>
              <Flex h="100%" alignItems="center" justifyContent={{ md: 'center' }}>
                <ImageShimmer
                  src={company.imageSrc}
                  alt={company.name}
                  width={company.imageSize.w}
                  height={company.imageSize.h}
                  style={{ objectFit: 'cover' }}
                  layout="intrinsic"
                />
              </Flex>
            </GridItem>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
